import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "M6.855 8.872c0-.852-.693-1.545-1.545-1.545-.851 0-1.544.693-1.544 1.545h.937a.608.608 0 0 1 1.214 0zm3.835-1.545c-.852 0-1.545.693-1.545 1.545h.938a.608.608 0 0 1 1.214 0h.937c0-.852-.693-1.545-1.544-1.545M8 11.615a1.69 1.69 0 0 1-1.45-.83l-.808.477A2.63 2.63 0 0 0 8 12.552c.923 0 1.788-.494 2.258-1.29l-.808-.477a1.69 1.69 0 0 1-1.45.83"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "M15.39 7.212a2.07 2.07 0 0 0-1.08-.573A6.64 6.64 0 0 0 8 2.053h-.314A1.37 1.37 0 0 1 6.317.685h-.938c0 .512.168.985.452 1.368h-.297A1.37 1.37 0 0 1 4.165.685h-.937a2.31 2.31 0 0 0 1.581 2.189A6.63 6.63 0 0 0 1.69 6.639a2.07 2.07 0 0 0-1.08.573A2.07 2.07 0 0 0 0 8.685c0 .549.212 1.067.597 1.459.3.306.68.508 1.093.586A6.64 6.64 0 0 0 8 15.316c2.881 0 5.43-1.87 6.31-4.586a2.07 2.07 0 0 0 1.093-.586A2.07 2.07 0 0 0 16 8.684a2.07 2.07 0 0 0-.61-1.472m-1.45 2.617-.352.007-.091.34A5.7 5.7 0 0 1 8 14.377a5.7 5.7 0 0 1-5.497-4.203l-.091-.34-.352-.006A1.15 1.15 0 0 1 .937 8.685 1.143 1.143 0 0 1 2.06 7.54l.352-.006.091-.34A5.7 5.7 0 0 1 8 2.99c.847 0 1.537.69 1.537 1.536 0 .848-.69 1.537-1.537 1.537s-1.537-.69-1.537-1.537h-.937A2.477 2.477 0 0 0 8 7.002a2.477 2.477 0 0 0 2.224-3.558 5.7 5.7 0 0 1 3.273 3.75l.091.34.352.006a1.14 1.14 0 0 1 1.122 1.145 1.15 1.15 0 0 1-1.122 1.144"
}, null, -1), a = [
  o,
  n
];
function r(h, s) {
  return t(), l("svg", c, [...a]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
